/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M762.5 200l37.5 37.5L537.5 500 800 762.5 762.5 800 500 537.5 237.5 800 200 762.5 462.5 500 200 237.5l37.5-37.5L500 462.5z"/>'
  }
})
